import { useState, useEffect, useMemo } from 'react'
import axios from 'axios'
import i18n from 'i18n'
import DefaultError from 'components/Error/DefaultError/DefaultError'
import {
  isAlert,
  isBlocking,
  isInformative,
  isSnackbar,
  redirectIfSessionOver,
  redirectIfUnauthorized,
} from 'utils/CheckRequests/checkRequests.utils'
import RebrandingProvider from 'components/NavV2/shared/RebrandingProvider'

// eslint-disable-next-line react/display-name
const checkRequest = (WrappedComponent) => (props) => {
  const [error, setError] = useState(null)

  const reqInterceptor = useMemo(
    () =>
      axios.interceptors.request.use((req) => {
        setError(null)
        return req
      }),
    []
  )

  const resInterceptor = useMemo(
    () =>
      axios.interceptors.response.use(
        (res) => res,
        (err) => {
          setError(err.response)
          return Promise.reject(err)
        }
      ),
    []
  )

  useEffect(() => {
    return () => {
      // Clear interceptors for prevent using much more than it's needed for each separete component
      axios.interceptors.request.eject(reqInterceptor)
      axios.interceptors.response.eject(resInterceptor)
    }
  }, [error, reqInterceptor, resInterceptor])

  if (!error) return <WrappedComponent {...props} />

  if (!isInformative(error?.config) && !isSnackbar(error?.config) && !isAlert(error?.config)) {
    if (isBlocking(error)) {
      return (
        <RebrandingProvider>
          <DefaultError
            actionText={i18n.t('Por favor, inténtalo más tarde.')}
            description={i18n.t(
              'Algo salió mal... Estamos trabajando en ello para que vuelva a funcionar.'
            )}
            title={i18n.t('¡Oops!')}
          />
        </RebrandingProvider>
      )
    }

    redirectIfUnauthorized(error)
    redirectIfSessionOver(error)
  }

  return <WrappedComponent {...props} />
}

export default checkRequest
